import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { useLang } from "@/lib/lang";
import { JOIN_OPTIONS, fadeUp, stagger } from "./constants";

/**
 * "Junte-se à DiTours" — 3 cards for Partner (hotel/agency), Driver and Fleet applications.
 */
export default function JoinSection({ onOpenJoin }) {
  const { t } = useLang();
  return (
    <motion.section
      id="join"
      className="dt-section dt-section--alt"
      data-testid="join-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      variants={stagger}
    >
      <div className="dt-section__wrap">
        <motion.p className="dt-section__eyebrow" variants={fadeUp}>{t("landing_join_eyebrow")}</motion.p>
        <motion.h2 className="dt-section__title" variants={fadeUp}>{t("landing_join_title")}</motion.h2>
        <motion.p className="dt-section__desc" variants={fadeUp}>{t("landing_join_desc")}</motion.p>
        <motion.div className="dt-join-grid" variants={stagger}>
          {JOIN_OPTIONS.map((opt) => {
            const Icon = opt.icon;
            return (
              <motion.div
                key={opt.key}
                className="dt-join-card"
                variants={fadeUp}
                data-testid={`join-card-${opt.key}`}
              >
                <div className="dt-join-card__icon"><Icon size={26} /></div>
                <h3 className="dt-join-card__title">{t(`landing_join_${opt.key}_title`)}</h3>
                <p className="dt-join-card__tag">{t(`landing_join_${opt.key}_tagline`)}</p>
                <ul className="dt-join-card__bullets">
                  {[1, 2, 3].map((n) => (
                    <li key={n}><Check size={14} /> {t(`landing_join_${opt.key}_b${n}`)}</li>
                  ))}
                </ul>
                <button
                  type="button"
                  className="dt-btn dt-btn--primary dt-join-card__cta"
                  onClick={() => onOpenJoin(opt.key)}
                  data-testid={`join-cta-${opt.key}`}
                >
                  {t("landing_join_cta")} <ArrowRight size={14} />
                </button>
                <Link
                  to="/login"
                  className="dt-join-card__login"
                  data-testid={`join-login-${opt.key}`}
                >
                  {t("landing_join_already_login")} <span>{t("landing_join_enter_portal")} →</span>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </motion.section>
  );
}
